import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=b71b7ce4&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=b71b7ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71b7ce4",
  null
  
)

export default component.exports